import state from './moduleAddressManagementState.js'
import mutations from './moduleAddressManagementMutations.js'
import actions from './moduleAddressManagementActions.js'
import getters from './moduleAddressManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
